



























import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import { agentApi } from "@/getinfo-api";
import { Condition as ICondition } from "@/api-v2/agent/models";
import ConditionForm from "@/components/condition/ConditionForm.vue";
import { cloneDeep } from "lodash";

@Component({
  components: { ConditionForm, CPage }
})
export default class ConditionEdit extends Vue {
  isLoading: boolean = false;
  condition!: ICondition;

  data() {
    return {
      condition: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "conditionList" },
        label: this.$tc(this.$translate.ConditionList)
      },
      {
        to: { name: "conditionView", params: { id: this.$route?.params?.id } },
        label: this.condition?.title
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async saveHandler(condition: ICondition) {
    try {
      this.isLoading = true;
      const _conditions = cloneDeep(condition);

      _conditions.value = _conditions?.percent
        ? _conditions.value
        : this.$converter.setPrice(_conditions.value);

      await agentApi.Condition.editCondition(condition.id!, _conditions);
      await this.$router.push({
        name: "conditionView",
        params: { id: condition.id! }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  cancelHandler() {
    this.$router.push({
      name: "conditionView",
      params: { id: this.$route.params.id }
    });
  }

  async deleteHandler(id: string) {
    try {
      this.isLoading = true;
      await agentApi.Condition.deleteCondition(id);
      await this.$router.push({
        name: "conditionView",
        params: { id: this.$route.params.id }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async getCondition() {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Condition.getCondition(
        this.$route.params.id
      );
      this.condition = data;
      this.condition.value = this.condition?.percent
        ? this.condition?.value
        : this.$converter.getPrice(this.condition.value);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getCondition();
  }
}
